import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { RequestBody, RequestResponse, ZenitEndpoint } from '../../models/request.model';
import { ZenitEvent } from '../../models/zenit-general.model';

import { BrowserOnly } from '@core/data-providers/platform/platform.decorators';
import { ConfigService } from '@core/services/config/config.service';
import { ConfigRequired } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ZenitEventApiService {
    constructor(
        private readonly http: HttpClient,
        private readonly configService: ConfigService,
    ) { }

    @BrowserOnly<ZenitEventApiService, Observable<undefined>>(of(undefined))
    public postEvent$(event: ZenitEvent, endpoint: ZenitEndpoint): Observable<RequestResponse> {
        const url: string = this.getZenitEndpoint(endpoint);

        const body: RequestBody<typeof event> = {
            records: [{
                value: event,
            }],
        };

        return this.http.post<RequestResponse>(url, body);
    }

    @ConfigRequired<ZenitEventApiService, Error>(new Error('Configuration not found'))
    private getZenitEndpoint(endpoint: ZenitEndpoint): string {
        return `${this.configService.getConfigUrl<string>('baseUrl')}/integration/zenit/topics/meccano.md.pro.store.${endpoint}`;
    }
}
